import { createSlice } from '@reduxjs/toolkit';
import { AxiosResponseModel } from '../../@types/base';
import axios from '../../utils/axios';
import { CONSTS } from './const';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import { dispatch } from '../store';
import {
  HealthCheckStatus,
  HealthCheckStatusData
} from '../../@types/healthCheck';

type HealthCheckState = {
  healthCheckPayload: HealthCheckStatusData | null;
  healthCheckError: boolean;
};

const initialState: HealthCheckState = {
  healthCheckPayload: null,
  healthCheckError: false
};

const slice = createSlice({
  name: 'healthCheck',
  initialState,
  reducers: {
    getHealthStatusSuccess(state, action) {
      state.healthCheckPayload = action.payload;
      state.healthCheckError = false;
    },

    hasErrorGetHealthStatusSuccess(state) {
      state.healthCheckPayload = null;
      state.healthCheckError = true;
    }
  }
});

export default slice.reducer;

export async function getHealthStatus() {
  // dispatch(slice.actions.startFaceSearchDetailLoading());
  // dispatch(slice.actions.startDetailLoading());
  try {
    const response: AxiosResponseModel<HealthCheckStatusData> = await axios
      .get(`${CONSTS.HEALTHCHECK_GET_GET_HEALTHSTATUS}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorGetHealthStatusSuccess());
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.getHealthStatusSuccess(response.data?.data || null)
      );
    } else {
      dispatch(slice.actions.hasErrorGetHealthStatusSuccess());
    }
    return response.data?.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorGetHealthStatusSuccess());
  }
  return null;
}
